/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/job.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { ApiJob, ApiListJobsResponse, GoogleRpcStatus } from '../models/index';
import {
  ApiJobFromJSON,
  ApiJobToJSON,
  ApiListJobsResponseFromJSON,
  ApiListJobsResponseToJSON,
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusToJSON,
} from '../models/index';

export interface CreateJobRequest {
  job: ApiJob;
}

export interface DeleteJobRequest {
  id: string;
}

export interface DisableJobRequest {
  id: string;
}

export interface EnableJobRequest {
  id: string;
}

export interface GetJobRequest {
  id: string;
}

export interface ListJobsRequest {
  page_token?: string;
  page_size?: number;
  sort_by?: string;
  resource_reference_key_type?: ListJobsResourceReferenceKeyTypeEnum;
  resource_reference_key_id?: string;
  filter?: string;
}

/**
 *
 */
export class JobServiceApi extends runtime.BaseAPI {
  /**
   * Creates a new job.
   */
  async createJobRaw(
    requestParameters: CreateJobRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiJob>> {
    if (requestParameters['job'] == null) {
      throw new runtime.RequiredError(
        'job',
        'Required parameter "job" was null or undefined when calling createJob().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/jobs`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ApiJobToJSON(requestParameters['job']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiJobFromJSON(jsonValue));
  }

  /**
   * Creates a new job.
   */
  async createJob(
    job: ApiJob,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiJob> {
    const response = await this.createJobRaw({ job: job }, initOverrides);
    return await response.value();
  }

  /**
   * Deletes a job.
   */
  async deleteJobRaw(
    requestParameters: DeleteJobRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling deleteJob().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/jobs/{id}`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Deletes a job.
   */
  async deleteJob(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.deleteJobRaw({ id: id }, initOverrides);
    return await response.value();
  }

  /**
   * Stops a job and all its associated runs. The job is not deleted.
   */
  async disableJobRaw(
    requestParameters: DisableJobRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling disableJob().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/jobs/{id}/disable`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Stops a job and all its associated runs. The job is not deleted.
   */
  async disableJob(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.disableJobRaw({ id: id }, initOverrides);
    return await response.value();
  }

  /**
   * Restarts a job that was previously stopped. All runs associated with the job will continue.
   */
  async enableJobRaw(
    requestParameters: EnableJobRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling enableJob().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/jobs/{id}/enable`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Restarts a job that was previously stopped. All runs associated with the job will continue.
   */
  async enableJob(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.enableJobRaw({ id: id }, initOverrides);
    return await response.value();
  }

  /**
   * Finds a specific job by ID.
   */
  async getJobRaw(
    requestParameters: GetJobRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiJob>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling getJob().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/jobs/{id}`;
    urlPath = urlPath.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id'])));

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiJobFromJSON(jsonValue));
  }

  /**
   * Finds a specific job by ID.
   */
  async getJob(
    id: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiJob> {
    const response = await this.getJobRaw({ id: id }, initOverrides);
    return await response.value();
  }

  /**
   * Finds all jobs.
   */
  async listJobsRaw(
    requestParameters: ListJobsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ApiListJobsResponse>> {
    const queryParameters: any = {};

    if (requestParameters['page_token'] != null) {
      queryParameters['page_token'] = requestParameters['page_token'];
    }

    if (requestParameters['page_size'] != null) {
      queryParameters['page_size'] = requestParameters['page_size'];
    }

    if (requestParameters['sort_by'] != null) {
      queryParameters['sort_by'] = requestParameters['sort_by'];
    }

    if (requestParameters['resource_reference_key_type'] != null) {
      queryParameters['resource_reference_key.type'] =
        requestParameters['resource_reference_key_type'];
    }

    if (requestParameters['resource_reference_key_id'] != null) {
      queryParameters['resource_reference_key.id'] = requestParameters['resource_reference_key_id'];
    }

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['authorization'] = await this.configuration.apiKey('authorization'); // Bearer authentication
    }

    let urlPath = `/apis/v1beta1/jobs`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiListJobsResponseFromJSON(jsonValue),
    );
  }

  /**
   * Finds all jobs.
   */
  async listJobs(
    page_token?: string,
    page_size?: number,
    sort_by?: string,
    resource_reference_key_type?: ListJobsResourceReferenceKeyTypeEnum,
    resource_reference_key_id?: string,
    filter?: string,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ApiListJobsResponse> {
    const response = await this.listJobsRaw(
      {
        page_token: page_token,
        page_size: page_size,
        sort_by: sort_by,
        resource_reference_key_type: resource_reference_key_type,
        resource_reference_key_id: resource_reference_key_id,
        filter: filter,
      },
      initOverrides,
    );
    return await response.value();
  }
}

/**
 * @export
 */
export const ListJobsResourceReferenceKeyTypeEnum = {
  UNKNOWN_RESOURCE_TYPE: 'UNKNOWN_RESOURCE_TYPE',
  EXPERIMENT: 'EXPERIMENT',
  JOB: 'JOB',
  PIPELINE: 'PIPELINE',
  PIPELINE_VERSION: 'PIPELINE_VERSION',
  NAMESPACE: 'NAMESPACE',
} as const;
export type ListJobsResourceReferenceKeyTypeEnum =
  (typeof ListJobsResourceReferenceKeyTypeEnum)[keyof typeof ListJobsResourceReferenceKeyTypeEnum];
